/// <reference path="koyori.ts" />

/**
 * 入力コンポーネントの基底となるクラスです。
 * <dl>
 * <dt>属性</dt>
 * <dd>name: 名前</dd>
 * <dd>label: ラベル</dd>
 * <dd>message: メッセージ</dd>
 * <dd>status: コンポーネントの色（active、info、warning、errorのいずれか）</dd>
 * <dd>value: 値</dd>
 * <dd>disabled: 無効化</dd>
 * </dl>
 */
class KoyoriInput extends KoyoriElement {

	static get observedAttributes() {
		return ['label', 'message'].concat(this.inputAttributes);
	}

	static get inputAttributes() {
		return ['value', 'name', 'disabled'];
	}

	/** ラベルエレメント */
	protected labelElement: HTMLElement;

	/** 入力エレメント */
	protected inputElement: HTMLElement;

	/** メッセージエレメント */
	protected messageElement: HTMLElement;

	/** ラッパエレメント */
	protected wrapperElement: HTMLElement;

	constructor() {
		super();

		this.classList.add('koy-input');

		this.wrapperElement = <HTMLElement>this.querySelector(".koy-input-wrapper");
		if (this.wrapperElement == null) {
			this.wrapperElement = document.createElement('label');
			this.wrapperElement.classList.add('koy-input-wrapper');
			{
				this.labelElement = document.createElement('span');
				this.labelElement.classList.add('koy-input-label');
				this.labelElement.classList.add('koy-hide');
				this.wrapperElement.appendChild(this.labelElement);

				this.inputElement = document.createElement(this.getInputTag());
				this.inputElement.classList.add('koy-input-element');
				if (this.getInputType()) {
					this.inputElement.setAttribute('type', this.getInputType());
				}
				this.wrapperElement.appendChild(this.inputElement);
			}
			this.appendChild(this.wrapperElement);

			this.messageElement = document.createElement('div');
			this.messageElement.classList.add('koy-input-message');
			this.appendChild(this.messageElement);
		} else {
			this.labelElement = <HTMLElement>this.querySelector('.koy-input-label');
			this.inputElement = <HTMLElement>this.querySelector('.koy-input-element');
			this.messageElement = <HTMLElement>this.querySelector('.koy-input-message');
		}

		window.addEventListener('resize', () => {
			this.updateMessageElementStyle();
		});
	}

	connectedCallback(): void {
		super.connectedCallback();
	}

	attributeChangedCallback(attrName: string, oldVal: string, newVal: string): void {
		super.attributeChangedCallback(attrName, oldVal, newVal);

		if (this.getInputAttributes().indexOf(attrName) >= 0) {
			let current = this.inputElement.getAttribute(attrName);
			if (current != newVal) {
				if (newVal == null) {
					this.inputElement.removeAttribute(attrName);
				} else {
					this.inputElement.setAttribute(attrName, newVal);
				}
			}
		}
	}

	/**
	 * フォーカスを当てます。
	 */
	focus(): void {
		(<HTMLInputElement>this.inputElement).focus();
	}

	/**
	 * @return 設定されている値
	 */
	get value(): string {
		return (<HTMLInputElement>this.inputElement).value;
	}

	/**
	 * @param value 設定する値
	 */
	set value(value: string) {
		(<HTMLInputElement>this.inputElement).value = value;
	}
	
	/**
	 * @return 変更イベントを取得する属性のリスト
	 */
	protected getObservedAttributes(): string[] {
		return KoyoriInput.observedAttributes;
	}

	/**
	 * @return inputタグに設定する属性のリスト
	 */
	protected getInputAttributes(): string[] {
		return KoyoriInput.inputAttributes;
	}

	protected labelChanged(value: string): void {
		if (this.labelElement == undefined) {
			return;
		}
		if (value == null) {
			this.labelElement.textContent = '';
			this.labelElement.classList.add('koy-hide');
		} else {
			this.labelElement.textContent = value;
			this.labelElement.classList.remove('koy-hide');
		}
	}

	protected messageChanged(value: string): void {
		if (this.messageElement == undefined) {
			return;
		}
		this.messageElement.textContent = value;
		if (value == null) {
			this.messageElement.classList.add('koy-hide');
		} else {
			this.messageElement.classList.remove('koy-hide');
			setTimeout(() => {
				this.updateMessageElementStyle();
			}, 0);
		}
	}

	/**
	 * @return 入力タグ。
	 */
	protected getInputTag(): string {
		return 'input';
	}

	/**
	 * @return 入力タグのtype属性の値
	 */
	protected getInputType(): string {
		return 'text';
	}

	/**
	 * メッセージエレメントのスタイルを変更します。
	 */
	protected updateMessageElementStyle() {
		let style = getComputedStyle(this.wrapperElement);
		if (style.flexWrap == 'nowrap') {
			this.messageElement.style.marginLeft = this.labelElement.offsetWidth + 'px';
		} else {
			this.messageElement.style.marginLeft = '0';
		}
		this.messageElement.style.width = this.inputElement.offsetWidth + 'px';
	}

}
